/* eslint-disable no-undef */
import { useContext, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { LayoutContext } from '../../contexts/layout';
import { setFormFieldMessage } from '../../redux/actions/forms';
import { IFormItemWrapperProps } from '../../types/components/form-item-wrapper';
import useRest from '../useRest';

export const useOnValueChangeAction = ({ fieldName, onValueChangeAction }: IFormItemWrapperProps) => {
    const { layoutId } = useContext(LayoutContext);
    const dispatch = useDispatch();
    const timeout = useRef<NodeJS.Timeout>();
    const rest = useRest();

    const executeAction = async (value: string) => {
        if (onValueChangeAction instanceof Object && typeof fieldName === 'string') {
            const result = await rest.fetch({
                method: 'post',
                objectName: onValueChangeAction.action,
                data: { value },
            });
            dispatch(
                setFormFieldMessage(
                    layoutId,
                    fieldName,
                    result.response?.data?.message || '',
                    result.response?.data?.className,
                ),
            );
        }
    };

    const executeOnValueChangeAction = async (value: string) => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => executeAction(value), onValueChangeAction?.timeout || 1000);
    };

    return {
        executeOnValueChangeAction,
    };
};
